"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowExactWidth = void 0;
var tslib_1 = require("tslib");
/**
 * 获取准确的行宽，只有全部列都声明了具体数值的列宽时才可取得
 */
function getRowExactWidth(columns) {
    var e_1, _a;
    var width = 0;
    try {
        for (var columns_1 = tslib_1.__values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
            var column = columns_1_1.value;
            if (typeof column.width !== "number") {
                return null;
            }
            width += column.width;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return width;
}
exports.getRowExactWidth = getRowExactWidth;
//# sourceMappingURL=get-row-exact-width.js.map